import { Injectable } from '@angular/core';
import { RestService, Rest, ABP } from '@abp/ng.core';
import { AppModuleManagement } from '../models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AppModuleManagementService {
    apiName = 'TerminalManagement';
    constructor(private rest: RestService) { }

    create(body: AppModuleManagement.CreateAppModuleRequest): Observable<AppModuleManagement.AppModuleItem> {
        const request: Rest.Request<AppModuleManagement.CreateAppModuleRequest> = {
            method: 'POST',
            url: '/api/TerminalManagement/AppModules',
            body,
        };

        return this.rest.request<AppModuleManagement.CreateAppModuleRequest, AppModuleManagement.AppModuleItem>(request, {
            apiName: this.apiName,
        });

    }

    update(body: AppModuleManagement.UpdateAppModuleRequest): Observable<AppModuleManagement.AppModuleItem> {
        let url = `/api/TerminalManagement/AppModules/${body.id}`;
        delete body.id;

        const request: Rest.Request<AppModuleManagement.UpdateAppModuleRequest> = {
            method: 'PUT',
            url,
            body,
        };

        return this.rest.request<AppModuleManagement.UpdateAppModuleRequest, AppModuleManagement.AppModuleItem>(request, {
            apiName: this.apiName,
        });
    }

    delete(id: string) {
        const request: Rest.Request<null> = {
            method: 'DELETE',
            url: `/api/TerminalManagement/AppModules/${id}`,
        };

        return this.rest.request<null, null>(request, { apiName: this.apiName });
    }

    get(id: string): Observable<AppModuleManagement.AppModuleItem> {
        const request: Rest.Request<null> = {
            method: 'GET',
            url: `/api/TerminalManagement/AppModules/${id}`,
        };

        return this.rest.request<null, AppModuleManagement.AppModuleItem>(request, { apiName: this.apiName });
    }

    list(params: AppModuleManagement.GetAppModuleRequest): Observable<AppModuleManagement.AppModuleResponse> {
        const request: Rest.Request<null> = {
            method: 'GET',
            url: `/api/TerminalManagement/AppModules/list`,
            params
        };

        return this.rest.request<null, AppModuleManagement.AppModuleResponse>(request, { apiName: this.apiName });
    }
}